module.exports = __webpack_public_path__ + "static/media/Warranty-badge-40k.f2e798c0.jpg";